import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// graphQL
import gql from 'graphql-tag';
// our components
import AuthContext from 'helpers/authContext';
import { Query } from 'components/common/Query';

/**
 * Query to fetch logged user
 */
export const ME_QUERY = gql`
  query {
    me {
      id
      fullname
      email
      phone
      rank
      userType
      photo {
        gcsKey
        url
      }
      allPermissions {
        name
        codename
      }
      permissionsGroups {
        name
      }
    }
  }
`;

/**
 * @description
 * Stateless component to manage autentication access.
 *
 * @param {Object} props - Component props.
 * @returns {*} Query component.
 */
const AuthProvider = props => {
  const { children, t } = props;
  return (
    <Query query={ME_QUERY}>
      {({ loading, error, data }) => {
        if (loading)
          return (
            <div style={{ height: '100vh', backgroundColor: 'aliceblue' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '90%',
                }}
              >
                <div style={{ textAlign: 'center' }}>
                  <h5>{t('common.loading')}</h5>
                  <div className="lds-ellipsis">
                    <div />
                    <div />
                    <div />
                    <div />
                  </div>
                </div>
              </div>
            </div>
          );
        if (error) return { children };
        return (
          <AuthContext.Provider value={data.me}>
            {children}
          </AuthContext.Provider>
        );
      }}
    </Query>
  );
};

/**
 * AuthProvider PropTypes
 * @param children - prop children components
 * @param t - prop from HOC with string translations
 */

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
  t: PropTypes.func.isRequired,
};
export default withTranslation()(AuthProvider);
